import React from 'react';
import { QuoteIcon } from 'lucide-react';
import type { Testimonial } from '../data/testimonials';
type TestimonialsProps = {
  testimonials: Testimonial[];
  eyebrow?: string;
  title?: string;
  subtitle?: string;
  background?: 'white' | 'blush';
};
export function Testimonials({
  testimonials,
  eyebrow = 'Colleague to colleague',
  title = 'What instructors are saying',
  subtitle,
  background = 'white'
}: TestimonialsProps) {
  const bg = background === 'white' ? 'bg-white' : 'bg-rose-soft';
  const grid = testimonials.length === 2 ? 'mx-auto max-w-4xl sm:grid-cols-2' : 'sm:grid-cols-2 lg:grid-cols-3';
  return <section aria-label={title} className={`w-full text-navy ${bg}`} data-id="element-245" data-mp="2x1bgpohwdh0i">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:py-20" data-id="element-246" data-mp="2s2rx3uqs0hbb">
        <div className="text-center" data-id="element-247" data-mp="v9g9pm6l60om">
          <p className="text-sm font-semibold text-lav-deep" data-id="element-248" data-mp="v8dn3qgaqkei">{eyebrow}</p>
          <h2 className="mt-3 font-display text-3xl font-semibold text-navy sm:text-5xl" data-id="element-249" data-mp="q9tyfiabiuig">{title}</h2>
          {subtitle && <p className="mx-auto mt-4 max-w-2xl text-sm text-navy-soft" data-id="element-250" data-mp="h5oq3c5zm87y">{subtitle}</p>}
        </div>

        <div className={`mt-9 grid gap-4 ${grid}`} data-id="element-251" data-mp="m5b2xkhwlmg8">
          {testimonials.map((item, i) => <figure key={i} className="flex flex-col rounded-3xl bg-white p-5 shadow-card ring-1 ring-paper-dark" data-id="element-252" data-mp="78k4bdg20ero" data-mpi={i}>
              <div className="flex items-center gap-2.5" data-id="element-253" data-mp="c7mwhxaxqqi8">
                {item.avatar ? <img src={item.avatar} alt={item.author} width={44} height={44} loading="lazy" className="h-11 w-11 rounded-full object-cover ring-2 ring-paper-dark" data-id="element-254" data-mp="zxha4h32wj3j" /> : <span className="flex h-11 w-11 items-center justify-center rounded-full bg-lav-soft" data-id="element-255" data-mp="q5la30hfmiwo">
                    <QuoteIcon className="h-4 w-4 text-lav-deep" aria-hidden="true" data-id="element-256" data-mp="v4o65vffpesi" />
                  </span>}
                {item.source && <span className="rounded-full bg-paper px-2.5 py-1 text-[11px] font-semibold text-navy-soft" data-id="element-257" data-mp="1nlqq32dm2cmr">{item.source}</span>}
              </div>
              <blockquote className="mt-3 text-[17px] italic leading-relaxed text-navy" data-id="element-258" data-mp="1xh7n6s4ya4ph">“{item.quote}”</blockquote>
              <figcaption className="mt-auto pt-4 text-xs text-navy-soft" data-id="element-259" data-mp="1sh38n7nlrk1w">
                <span className="block text-[13px] font-bold not-italic text-navy" data-id="element-260" data-mp="1ofhnkz0wzzgm">{item.author}</span>
                {item.role}
                {item.location && <span className="mt-0.5 block text-navy-muted" data-id="element-261" data-mp="1ejoejpmemo3l">{item.location}</span>}
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}